import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BatchService } from 'src/app/services/operations/batchFollowup.service';
import { GeneralService } from 'src/app/services/general.service';
import { IListOfValues, IUserList, IGetPermissionMandatoryField, ICommonList, IUserGroupList,IDripCampaignAction } from '../interface';
import { UserService } from 'src/app/services/user.service';
import { CommonMethodService } from '../common-method.service';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { ISendSMSLogsResponse, ISendSmsResponse, ISendEmailOutput, ISendEmailOutputModel, IPaymentResponseModel } from '../interface2';
import { twoWayService } from 'src/app/services/operations/two-way-text.service';
import { ToastrService } from 'ngx-toastr';
import { LetterAndNoticesService } from 'src/app/services/letterAndNotices.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { timer } from 'rxjs';
import { AppService } from 'src/app/services/app.service';
import { EFollowUpAction, EFollowUpPriority, EFollowUpStatus, ELOV_StoreOptions, EUserFunctions } from '../enum';
import { UserGroupService } from 'src/app/services/userGroups.service';
import { RingCentralCTService } from 'src/app/services/operations/ringcentral.service';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { CustomerService } from 'src/app/services/operations/customer.service';
import { IGetCustomerUnitNotes , IAlternateContactInfoList } from 'src/app/Shared/models/CustomerModel';
import { IResponseModel} from 'src/app/Shared/models/ProspectModel'

@Component({
    selector: 'edit-FollowUp',
    templateUrl: './editFollowUp-componsnt.html',
    styleUrls: ['./editFollowUp-componsnt.scss'],
    standalone: false
})
export class EditFollowUpComponent implements OnInit {
  @Input() section;
  @Input() callScriptFields = [];
  tempFollowupData;
  moduleName = '';
  Follow_det = true;
  Caller_det = false;
  BeforeSMS;
  AfterSMS;
  BeforeEmail;
  AfterEmail;
  notesGridData;

  @ViewChild('collectionPopup', { static: true }) collectionPopup: ModalDirective;
  @ViewChild('AssignedToDrop', { static: false }) AssignedToDrop: DropDownListComponent;
  @Input() facilityId: number;
  @Input() SelectedFollowUpData: any;
  @Input() moduleType: number;
  @Input() followUpObject;
  @Output() emitFollowUpModel: EventEmitter<any> = new EventEmitter();
  @Input() CountryCode;
  @Input() selectedDispositionName;
  EditFollowUpForm: FormGroup;
  FollowUpData: any;
  loaderIcon: Promise<boolean>;
  FollowUpActionlist: IListOfValues[];
  StatusActionlist: IListOfValues[];
  priorityActionlist: IListOfValues[];
  NoteDetail = false;
  public groupFields: Object = { groupBy: 'Category', text: 'Name', value: 'Id' };
  public height: string = '200px';
  public groupWaterMark: string = 'Select';
  lovStore: IListOfValues[] = [];
  assignedToList: any = [];
  usersList: IUserList[];
  userGroupList: any;
  enableCollectionCall = false;
  minDate = new Date();
  remainderMinDate = new Date();
  FollowUp_sms_modal: boolean;
  currentNotesId = 0;
  maxRemainderDate;
  editRight: boolean;
  editRightFalseMessage: string;
  createRightFalseMessage: string;
  RemainderDatederRequired = false;
  showTodayButtonReminderDate = false;
  SysDate = new Date();
  logs;
  filteredLogs;
  smstext = '';
  smstenantId;
  isCellPhoneAvailable: boolean = false;
  noMessages = 'No Messages to Display';
  fullphonenumber;
  callscrpt = '';
  drpactionid;
  templateList: any[];
  templateTTTypeID = 0;
  emailBodyEditor = '';
  mailfullContent;
  disableEmailSend = true;
  public rteValue: string = '';
  selectedTemplateName = '';
  public toolbarConfig: object = {
    items: ['Undo', 'Redo', '|',
      'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
      'SubScript', 'SuperScript', '|',
      'LowerCase', 'UpperCase', '|',
      'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
      'Indent', 'Outdent', '|', 'CreateLink',
      'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
  };
  @ViewChild('defaultRTE', { static: false })
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  @ViewChild('SMSModal', { static: true }) smsModalBox: ModalDirective;
  @ViewChild('EmailModal', { static: true }) emailModalBox: ModalDirective;
  @ViewChild('AlternateContactPopUp', { static: false }) AlternateContactPopUp: ModalDirective;
  modalConfig = {
  backdrop: true,
  ignoreBackdropClick: true
};
alternateModalConfig ={
    backdrop: 'static'
}
  sub: any;
  companySettingDetails: any;
  setMandatoryCalled = false;
  createRightAdHocEmail = false;
  viewRightAdHocEmail = false;
  createRightAdHocSMS = false;
  viewRightAdHocSMS = false;
  isAssignedToUserGroup = false;
  propertyProtectionLabel: String;
  showdripdetails: boolean =false;
  DripcampaignName: any;
  DripcampaignActionName: any;
  customerNotesList: IGetCustomerUnitNotes[] = [];
  @ViewChild('NotesPopup', { static: false }) NotesPopup!: ModalDirective;
  gotoalternateContact = false;
  public alternateContactInfoList: IAlternateContactInfoList[];
  gateSystemResponse;

  constructor(private batchService: BatchService,
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private userService: UserService,
    private commonService: CommonMethodService,
    private twoWayService: twoWayService,
    private toastr: ToastrService,
    private letterAndNoticesService: LetterAndNoticesService,
    private userSessionService: UserSessionService,
    private appService: AppService,
    private userGroupService: UserGroupService,
    private ringCentralCTService: RingCentralCTService,
    private prospectService: ProspectService,
    private customerService: CustomerService  ) { }

  ngOnInit() {
    this.setUserPermissions();
    this.EditFollowUpForm = this.formBuilder.group({
      Id: [''],
      checkboxCollectionCall: [],
      SelectedFollowUpAction: [],
      MentionedFollowUpdate: [],
      SelectedStatus: [],
      SelectedPriority: [],
      Reminderdate: [],
      SelectedAssignedTo: [],
      EditableNotes: []

    });
    this.companySettingDetails = this.userSessionService.InServiceGetCompanySettings();

    if (this.followUpObject) {
      this.FollowUpData = this.followUpObject;
      this.updateIsCellPhoneAvailable();
      this.setMandatoryField();
      this.getFacilityMiscellaneousSettings(this.FollowUpData.FacilityId);
    } else {
      this.isCellPhoneAvailable = false;
      this.setMandatoryCalled = false;
    }
    this.setDefaultValues();
    if (this.moduleType === 2) {
      this.minDate = new Date();
    }
    this.getUserList();
    this.getUserGroupList();
  }

   ngAfterViewInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.moduleType == 2) {
      if (this.FollowUpData && changes['selectedDispositionName'] && changes['selectedDispositionName'].currentValue && changes['selectedDispositionName'].currentValue !== undefined) {
        this.FollowUpData.DispositionName = this.selectedDispositionName;
      }
    }
    if (this.moduleName == "prospectsModule") {
      if (this.followUpObject) {
        this.getFacilityMiscellaneousSettings(this.followUpObject.FacilityId);
        this.setMandatoryField();
      } else {
        this.setMandatoryCalled = false;
      }
    }
  }

  getCalls() {
    if (this.userSessionService.lovList.length) {
      this.setListOfValuesBasedOnType();
      this.lovStore.map((ele) => {
        ele['Id'] = ele.Id < 0 ? ele.Id : (-1 * ele.Id);
        ele['Category'] = 'Stores';
      });
      if (this.assignedToList.length) {
        if (this.assignedToList.findIndex(o => o.Id == ELOV_StoreOptions.Store) === -1) {
          this.assignedToList = this.assignedToList.concat(this.lovStore);
        }
      } else {
        this.assignedToList = this.assignedToList.concat(this.lovStore);
      }
      if (this.moduleType === 1) {
        this.setForm();
      }
      this.assignedToList.sort((a, b) => {
        if (a.Category < b.Category) { return -1; }
        if (a.Category > b.Category) { return 1; }
        return 0;
      });
      if (this.moduleType === 2 && !this.tempFollowupData) {
        this.setForm();
      }
    } else {
      this.generalService.getAllListOfValues().subscribe((response: any) => {
        this.userSessionService.lovList = response;
        this.setListOfValuesBasedOnType();
        this.lovStore.map((ele) => {
          ele.Id = ele.Id < 0 ? ele.Id : (-1 * ele.Id);
          ele['Category'] = 'Stores';
        });
        if (this.assignedToList.length) {
          if (this.assignedToList.findIndex(o => o.Id == ELOV_StoreOptions.Store) === -1) {
            this.assignedToList = this.assignedToList.concat(this.lovStore);
          }
        } else {
          this.assignedToList = this.assignedToList.concat(this.lovStore);
        }
        if (this.moduleType === 1) {
          this.setForm();
        }
        this.assignedToList.sort((a, b) => {
          if (a.Category < b.Category) { return -1; }
          if (a.Category > b.Category) { return 1; }
          return 0;
        });
        if (this.moduleType === 2 && !this.tempFollowupData) {
          this.setForm();
        }
      });
    }
  }

  setListOfValuesBasedOnType() {
    this.priorityActionlist = this.userSessionService.getLovListForType(27);
    this.FollowUpActionlist = this.userSessionService.getLovListForType(28);
    this.StatusActionlist = this.userSessionService.getLovListForType(29);
    this.lovStore = this.userSessionService.getLovListForType(62);
  }

  setDefaultValues() {
    this.BeforeSMS = true;
    this.BeforeEmail = true;
  }

  setForm() {
    if (this.SelectedFollowUpData) {
      const source = timer(900)
      this.sub = this.appService.waitForStable$(source)
        .subscribe(val => {
          this.EditFollowUpForm.patchValue({
            SelectedFollowUpAction: this.SelectedFollowUpData.FollowUpActionId,
            MentionedFollowUpdate: this.SelectedFollowUpData.FollowUpDate,
            SelectedStatus: this.SelectedFollowUpData.StatusId,
            SelectedPriority: this.SelectedFollowUpData.PriorityId,
            Reminderdate: this.SelectedFollowUpData.ReminderDate,
          });
          if (this.SelectedFollowUpData.AssignedFacilityId) {
            this.EditFollowUpForm.patchValue({ SelectedAssignedTo: ELOV_StoreOptions.Store });
          } else {
            const assignedTo = this.SelectedFollowUpData.AssignedUserGroupId != 0 ? this.SelectedFollowUpData.AssignedUserGroupId : this.SelectedFollowUpData.AssignedUserId;
            this.EditFollowUpForm.patchValue({ SelectedAssignedTo: assignedTo });
          }
        });
      if (this.SelectedFollowUpData.FollowUpDate && this.SelectedFollowUpData.DripCampaignActionId) {
        this.EditFollowUpForm.controls['MentionedFollowUpdate'].disable();
      } else {
        this.EditFollowUpForm.controls['MentionedFollowUpdate'].enable();
      }
      this.isAssignedToUserGroup = this.SelectedFollowUpData.AssignedUserGroupId ? true : false;
    } else {
      this.EditFollowUpForm.patchValue({ SelectedAssignedTo: ELOV_StoreOptions.Store });
    }
  }

  getFollowUpData(obj, type) {
    this.showdripdetails = false;
    this.loaderIcon = Promise.resolve(true);
    obj.DripCampaignActionId = this.SelectedFollowUpData?.DripCampaignActionId;
    this.batchService.getFollowupData(obj).subscribe((res) => {
      this.FollowUpData = res;
      this.updateIsCellPhoneAvailable();
      if (type) {
        this.FollowUpData['Type'] = type;
      }
      this.FollowUpData.Email = this.FollowUpData.NoEmail ? this.companySettingDetails.General.GenericCustomerEmailAddress : this.FollowUpData.Email;
      this.smstenantId = obj.TenantId;
      if (obj.DripCampaignActionId) {
        this.drpactionid = obj.DripCampaignActionId;
      } else {
        this.drpactionid = null;
      }
      this.setMandatoryField();

      if (this.FollowUpData) {
        if (this.FollowUpData.MoveInDate) {
          this.FollowUpData.MoveInDate = this.commonService.getAPIDateTimeToLocalDatePart(this.FollowUpData.MoveInDate);
        }
        if (this.FollowUpData.PaidThruDate) {
          this.FollowUpData.PaidThruDate = this.commonService.getAPIDateTimeToLocalDatePart(this.FollowUpData.PaidThruDate);
        }
        if (this.FollowUpData.InquiryDate) {
          this.FollowUpData.InquiryDate = this.commonService.getAPIDateTimeToLocalDatePart(this.FollowUpData.InquiryDate);
        }
        if (this.FollowUpData.DateNeeded) {
          this.FollowUpData.DateNeeded = this.commonService.getAPIDateTimeToLocalDatePart(this.FollowUpData.DateNeeded);
        }
        if (this.FollowUpData.Disposition !== null) {
          this.FollowUpData.DispositionName = this.FollowUpData.Disposition;
        }
        if ((this.moduleType === 1) && (this.FollowUpData.Disposition !== null)) {
          this.AssignedToDrop.setDisabledState(true);
        } else {
          this.AssignedToDrop.setDisabledState(false);
        }
        if (this.FollowUpData.InquirySource !== null) {
          this.FollowUpData.InquirySource = this.FollowUpData.InquirySource;
        }
      }
      if(this.SelectedFollowUpData?.DripCampaignActionId){
        this.showdripdetails = true;
        this.EditFollowUpForm.controls['checkboxCollectionCall'].disable();
        this.DripcampaignName = this.SelectedFollowUpData.DripcampaignName
        this.DripcampaignActionName = this.SelectedFollowUpData.DripcampaignActionName
      }
      else{
        this.EditFollowUpForm.controls['checkboxCollectionCall'].enable();
        this.showdripdetails = false;
      }
      this.getFacilityMiscellaneousSettings(this.FollowUpData.FacilityId);
      this.checkGateSystemIntegrated(this.FollowUpData.FacilityId);
      this.getAlternateContactList(this.FollowUpData.LeaseNumber, this.FollowUpData.FacilityId);
      this.setForm();
      this.loaderIcon = Promise.resolve(false);
    }, (err) => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  ShowDetNote(noteId, type) {
    if (this.currentNotesId == noteId || this.NoteDetail) {
      this.NoteDetail = false;
      this.currentNotesId = 0;
    } else {
      this.NoteDetail = true;
      this.currentNotesId = noteId;
    }
  }

  HideNotePopUp(noteId) {
    this.currentNotesId = noteId;
    this.NoteDetail = false;
  }

  getUserList() {
    let userlIst = [];
    this.userService.GetFNameOrLNameOfUsers().subscribe((response: IUserList[]) => {
      this.usersList = response;
      this.usersList.map((ele) => { ele['Category'] = 'Users'; ele['Name'] = ele.FirstName + ' ' + ele.LastName; });
      this.usersList.map((element) => {
        if (this.assignedToList.findIndex(o => o.Id == element.Id) == -1) {
          userlIst.push(element);
        }
      });
      this.assignedToList = this.assignedToList.concat(userlIst);
      if (this.moduleType === 1) {
        this.setForm();
      }
      this.assignedToList.sort((a, b) => {
        if (a.Category < b.Category) { return -1; }
        if (a.Category > b.Category) { return 1; }
        return 0;
      });
      if (this.moduleType === 2 && !this.tempFollowupData) {
        this.setForm();
      }
    });
  }

  getUserGroupList() {
    this.userGroupService.getUserGroupsListsForOp().subscribe((response: IUserGroupList[]) => {
      this.userGroupList = response;
      // make User group id as negative to avoid id conflict with users list when combined
      this.userGroupList.map((ele) => { ele.Id = ele.Id * (-1), ele['Category'] = 'User Group'; ele['Name'] = ele.Name; });
      const userGroup = this.userGroupList.filter(element =>
        this.assignedToList.findIndex(o => o.Id === element.Id && o.Category === element.Category) === -1
      );
      this.assignedToList = this.assignedToList.concat(userGroup);
      if (this.moduleType === 1) {
        this.setForm();
      }
      this.assignedToList.sort((a, b) => {
        if (a.Category < b.Category) { return -1; }
        if (a.Category > b.Category) { return 1; }
        return 0;
      });
      if (this.moduleType === 2 && !this.tempFollowupData) {
        this.setForm();
      }
    });
  }

  makeFollowupModel() {
    this.EditFollowUpForm.controls['checkboxCollectionCall'].enable();
    this.EditFollowUpForm.controls['SelectedFollowUpAction'].enable();
    this.EditFollowUpForm.controls['SelectedStatus'].enable();
    this.EditFollowUpForm.controls['Reminderdate'].enable();
    this.EditFollowUpForm.controls['MentionedFollowUpdate'].enable();
    this.EditFollowUpForm.controls['SelectedPriority'].enable();
    this.EditFollowUpForm.controls['EditableNotes'].enable();

    let notesFollowups = [];
    let followupId = 0;
    if (this.SelectedFollowUpData) {
      if (this.SelectedFollowUpData.Id) {
        followupId = this.SelectedFollowUpData.Id;
      }
    }
    let facilityId;
    if (this.moduleType === 1) {
      if (this.SelectedFollowUpData.InquiryNumber) {
        facilityId = this.SelectedFollowUpData.InquiryFacilityId;
      } else if (this.SelectedFollowUpData.ReservationNumber) {
        facilityId = this.SelectedFollowUpData.ReservationFacilityId;
      } else {
        facilityId = this.SelectedFollowUpData.LeaseFacilityId;
      }
    } else {
      facilityId = this.FollowUpData.FacilityId;
    }
    let isCallCenterGroup = false;
    if (this.userSessionService) {
      isCallCenterGroup = this.userSessionService.isCallcenterAgent === true ? true : false;
    }
    const FollowupObj = {
      NotesId: 0,
      LeaseNo: this.FollowUpData && this.FollowUpData.LeaseNumber && this.FollowUpData.LeaseNumber > 0 ? this.FollowUpData.LeaseNumber : null,
      FacilityId: facilityId,
      ReservationNumber: this.FollowUpData.ReservationNumber,
      ReservationFacilityId: facilityId,
      InquiryNumber: this.FollowUpData.InquiryNumber,
      InquiryFacilityId: facilityId,
      InquiryNotesFacilityId: null,
      FollowUpId: followupId,
      NotesDate: new Date(),
      Text: this.EditFollowUpForm.value.EditableNotes,
      CustomerNotes: false,
      CollectionCall: this.EditFollowUpForm.value.checkboxCollectionCall == true? true : false,
      PaymentReceiptId: null,
      DisplayAlert: isCallCenterGroup,
      UnitNo: this.FollowUpData.UnitNumber,
      Creator: null,
    };
    notesFollowups.push(FollowupObj);
    let Fobj;
    if (this.EditFollowUpForm.dirty) {
      Fobj = {
        Id: followupId,
        AssignedFacilityId: this.EditFollowUpForm.value.SelectedAssignedTo === ELOV_StoreOptions.Store && !this.isAssignedToUserGroup ? ELOV_StoreOptions.Store : null,
        AssignedUserId: this.EditFollowUpForm.value.SelectedAssignedTo !== ELOV_StoreOptions.Store && !this.isAssignedToUserGroup ? this.EditFollowUpForm.value.SelectedAssignedTo : null,
        AssignedUserGroupId: this.isAssignedToUserGroup ? this.EditFollowUpForm.value.SelectedAssignedTo * (-1) : null,
        AssignedUserName: null,
        FollowUpActionId: this.EditFollowUpForm.value.SelectedFollowUpAction,
        FollowUpActionName: null,
        PriorityId: this.EditFollowUpForm.value.SelectedPriority,
        PriorityName: null,
        InquiryNumber: this.FollowUpData.InquiryNumber,
        InquiryFacilityId: facilityId,
        ReservationNumber: this.FollowUpData.ReservationNumber,
        ReservationFacilityId: facilityId,
        LeaseNumber: this.FollowUpData && this.FollowUpData.LeaseNumber > 0 ? this.FollowUpData.LeaseNumber : null,
        LeaseFacilityId: facilityId,
        FollowUpDate: this.EditFollowUpForm.value.MentionedFollowUpdate,
        ReminderDate: this.EditFollowUpForm.value.Reminderdate,
        StatusId: this.EditFollowUpForm.value.SelectedStatus,
        CollectionCall: this.EditFollowUpForm.value.checkboxCollectionCall,
        StoreUnit: null,
        NotesInfo: notesFollowups === null ? [] : notesFollowups,
      };
      this.tempFollowupData = Fobj;
    } else {
      Fobj = [];
    }
    this.emitFollowUpModel.emit(Fobj);
    this.resetForm();
  }

  EndCall() {
    this.Follow_det = true;
    this.Caller_det = false;
  }

  resetForm() {
    this.collectionPopup.hide();
    if (this.moduleName === 'customer') {
      this.EditFollowUpForm.patchValue({
        SelectedFollowUpAction: EFollowUpAction.PhoneCall,
        MentionedFollowUpdate: '',
        SelectedStatus: EFollowUpStatus.Open,
        SelectedPriority: EFollowUpPriority.Normal,
        Reminderdate: '',
        SelectedAssignedTo: ELOV_StoreOptions.Store,
        EditableNotes: '',
        IsUserGroupSelected: false
      });
      this.FollowUpData = null;
      this.isCellPhoneAvailable = false;
    } else if (this.moduleName === 'prospectsModule') {
      if (this.tempFollowupData) {
        this.EditFollowUpForm.patchValue({
          SelectedFollowUpAction: this.tempFollowupData.FollowUpActionId,
          MentionedFollowUpdate: this.tempFollowupData.FollowUpDate,
          SelectedStatus: EFollowUpStatus.Open,
          SelectedPriority: this.tempFollowupData.PriorityId,
          Reminderdate: this.tempFollowupData.ReminderDate,
          SelectedAssignedTo: this.tempFollowupData.AssignedFacilityId ? ELOV_StoreOptions.Store : (this.tempFollowupData.AssignedUserGroupId ? this.tempFollowupData.AssignedUserGroupId : this.tempFollowupData.AssignedUserId),
          EditableNotes: this.tempFollowupData.NotesInfo[0].Text
        });
      } else {
        this.EditFollowUpForm.reset();
        this.EditFollowUpForm.patchValue({
          SelectedFollowUpAction: EFollowUpAction.PhoneCall,
          SelectedPriority: EFollowUpPriority.Normal,
          MentionedFollowUpdate: '',
          EditableNotes: '',
          SelectedStatus: EFollowUpStatus.Open,
          Reminderdate: '',
          SelectedAssignedTo: ELOV_StoreOptions.Store
        });
      }
    }
    this.EditFollowUpForm.markAsUntouched();
    this.EditFollowUpForm.markAsPristine();
  }

  onLoadEnabledDates(args: any) {
    const FollowUpDate = new Date(new Date(this.EditFollowUpForm.value.MentionedFollowUpdate).setHours(0, 0, 0, 0));
    const targetDate = new Date(new Date(args.date).setHours(0, 0, 0, 0));
    if (targetDate.getTime() > FollowUpDate.getTime()) {
      args.isDisabled = true;
    }
  }

  setMandatoryField() {
    let facilityId;
    if (!this.setMandatoryCalled) {
      this.loaderIcon = Promise.resolve(true);
    }
    if (this.moduleType === 1) {
      if (this.SelectedFollowUpData.InquiryNumber) {
        facilityId = this.SelectedFollowUpData.InquiryFacilityId;
      } else if (this.SelectedFollowUpData.ReservationNumber) {
        facilityId = this.SelectedFollowUpData.ReservationFacilityId;
      } else {
        facilityId = this.SelectedFollowUpData.LeaseFacilityId;
      }
    } else {
      facilityId = this.FollowUpData.FacilityId ? this.FollowUpData.FacilityId : facilityId;
    }
    this.getDayEndCompletedDate(facilityId);
    this.generalService.GetMandatoryFieldsById(facilityId, 131)
      .subscribe((response: IGetPermissionMandatoryField) => {
        const data = response;
        if (!this.setMandatoryCalled) {
          this.loaderIcon = Promise.resolve(false);
          this.setMandatoryCalled = true;
        }
        if (data.Form.ListOfProperties.length !== 0) {
          data.Form.ListOfProperties.forEach(field => {
            if (field.Required) {
              this.EditFollowUpForm.get(field.Name).setValidators([Validators.required, Validators.pattern(/\S+/)]);
            } else {
              this.EditFollowUpForm.get(field.Name).setValidators(null);
            }
            this.EditFollowUpForm.controls[field.Name].updateValueAndValidity();
          });
        }
        if (this.moduleType === 1) {
          this.EditFollowUpForm.controls['SelectedFollowUpAction'].disable();
        }
        if (this.moduleType === 2 || (!this.editRight && (this.moduleType === 1))) {
          this.EditFollowUpForm.controls['SelectedStatus'].disable();
        }
        if (!this.editRight && (this.moduleType === 1)) {
          this.EditFollowUpForm.controls['Reminderdate'].disable();
          this.EditFollowUpForm.controls['MentionedFollowUpdate'].disable();
          this.EditFollowUpForm.controls['SelectedPriority'].disable();
          this.EditFollowUpForm.controls['EditableNotes'].disable();
        }
        if (this.moduleType === 2) {
          this.EditFollowUpForm.patchValue({
            checkboxCollectionCall: false,
            SelectedFollowUpAction: EFollowUpAction.PhoneCall,
            MentionedFollowUpdate: '',
            SelectedStatus: EFollowUpStatus.Open,
            SelectedPriority: EFollowUpPriority.Normal,
            Reminderdate: '',
            SelectedAssignedTo: ELOV_StoreOptions.Store,
            EditableNotes: ''
          });
        }
      });
  }

  setUserPermissions() {
    this.editRight = this.generalService.getUserPermissionsForModule(EUserFunctions['Follow-Ups']).EditRight;
    this.editRightFalseMessage = this.generalService.EditRightFalseMessage;
    this.createRightFalseMessage = this.generalService.CreateRightFalseMessage;

    let userPermissionAdHocEmail = this.generalService.getUserPermissionsForModule(EUserFunctions.DashboardEmailOption);
    this.createRightAdHocEmail = userPermissionAdHocEmail.CreateRight;
    this.viewRightAdHocEmail = userPermissionAdHocEmail.ViewRight;
    let userPermissionAdHocSMS = this.generalService.getUserPermissionsForModule(EUserFunctions.DashboardSMSOption);
    this.createRightAdHocSMS = userPermissionAdHocSMS.CreateRight;
    this.viewRightAdHocSMS = userPermissionAdHocSMS.ViewRight;
  }

  changeStartDate(value) {
    if ((this.EditFollowUpForm.value.Reminderdate !== '') && (this.EditFollowUpForm.value.Reminderdate != null)) {
      if (this.EditFollowUpForm.value.Reminderdate > value) {
        this.EditFollowUpForm.controls['Reminderdate'].setValue('');
      }
    }
  }

  sendTheSms() {
    this.fullphonenumber = '+' + this.CountryCode + this.FollowUpData.Phone;
    if (this.smstext === undefined || this.smstext.trim() === '' || this.smstext === null) {
      this.toastr.error('Text cannot be left blank', 'Failure', this.toasterConfig);
    } else {
      let phoneNumberArr = [];
      phoneNumberArr.push(this.fullphonenumber);
      var Messages = [];
      let singleMessage = {
        FromPhoneNumber: null,
        ToPhoneNumberList: phoneNumberArr,
        Message: this.smstext,
        TenantPhoneNumber: null,
        MessageStatus: 'sent',
        ErrorCode: null,
      };
      Messages.push(singleMessage);
      const Fobj = {
        LocationId: this.FollowUpData.FacilityId,
        AccountID: null,
        Token: null,
        ServiceId: 0,
        LeaseNumber: this.FollowUpData.LeaseNumber,
        FacilityId: this.FollowUpData.FacilityId,
        ReservationNumber: this.FollowUpData.ReservationNumber,
        ReservationFacilityId: null,
        InquiryNumber: this.FollowUpData.InquiryNumber,
        InquiryFacilityId: null,
        TenantId: this.smstenantId,
        TransactionTypeId: 17,
        SentSuccessfully: true,
        SMSCampaignId: null,
        SMSList: Messages,
      };
      this.twoWayService.SendSms(Fobj).subscribe((response: ISendSmsResponse) => {
        if (response.Success === true) {
          this.smstext = '';
          this.getSmsLogs();
        } else {
          this.smstext = '';
          this.toastr.error('Failed to Send SMS', 'Failure', this.toasterConfig);
        }
      });
    }
  }

  showButton() {
    if (this.EditFollowUpForm.value.SelectedFollowUpAction !== EFollowUpAction.PhoneCall) {
      this.EditFollowUpForm.patchValue({ checkboxCollectionCall: false });
    }
  }

  sendEmail() {
    let emailList = [];
    let emodel = {
      Subject: this.mailfullContent.EmailModel.Subject,
      EmailBody: this.rteValue,
      FromAddress: this.mailfullContent.EmailModel.FromAddress,
      ToAddress: this.FollowUpData.Email,
      CcAddress: this.mailfullContent.EmailModel.CcAddress,
      BccAddress: this.mailfullContent.EmailModel.BccAddress,
      ToList: [],
      CcList: [],
      BccList: [],
      Files: [],
    };
    let emailbody = {
      EmailIdentifier: 1,
      EmailModel: emodel,
      LeaseNo: this.FollowUpData.LeaseNumber ? this.FollowUpData.LeaseNumber : null,
      FacilityId: this.FollowUpData.FacilityId,
      ReservationNumber: this.FollowUpData.ReservationNumber,
      InquiryNumber: this.FollowUpData.InquiryNumber,
      FollowUpId: null,
      DripCampaignActionId: this.drpactionid,
      Description: this.selectedTemplateName,
      Type: 0,
      TypeReferenceId: 0,
      SendtoAlternate: true,
      TransactionTypeId: 0,
      Ip: '',
      SentTo: 386,
      SentRegisteredEmail: this.mailfullContent.SentRegisteredEmail ? true : false,
      TenantID: this.smstenantId,
    };
    emailList.push(emailbody);
    if (this.FollowUpData.Email) {
      this.twoWayService.sendEmail(emailList).subscribe((response: ISendEmailOutput[]) => {
        if (response && response.length > 0 && response[0].Success) {
          this.toastr.success('Email Sent Successfully', 'Success', this.toasterConfig);
        } else {
          this.toastr.error('Failed to send email', 'Failure', this.toasterConfig);
        }
      });
    } else {
      this.toastr.error('No email address Added', 'Failure', this.toasterConfig);
    }
    this.templateTTTypeID = 0;
    this.emailModalBox.hide();
  }

  getSmsLogs() {
    const obj = {
      FacilityId: this.FollowUpData.FacilityId,
      FilterText: 'all',
    };
    this.twoWayService.getSmsLogs(obj).subscribe((response: ISendSMSLogsResponse) => {
      this.logs = response;
      this.logs.forEach(element => {
        element.FacilityDateTime = element.FacilityDateTime?.replace('Z', '');
      });
      this.filteredLogs = this.logs.filter(o => o.TenantId === this.smstenantId);
      if (this.filteredLogs !== undefined) {
        if (this.filteredLogs.length > 0) {
          this.noMessages = '';
        }
      }
    });
  }

  openSmsModal() {
    if (this.createRightAdHocSMS) {
      this.getSmsLogs();
      this.smsModalBox.show();
    }
  }

  openemailModal() {
    if (this.createRightAdHocEmail) {
      this.getLettersAndNoticesTemplateListByTypeId();
      this.emailModalBox.show();
    }
  }

  closeSmsModal() {
    this.smstext = '';
    this.smsModalBox.hide();
  }

  closeemailModal() {
    this.emailModalBox.hide();
  }

  updateIsCellPhoneAvailable() {
    this.isCellPhoneAvailable = !!this.FollowUpData?.Phone;
  }

  getcallingScript(dripid) {
    let id = 0;
    if (!dripid) {
      id = 0;
    } else {
      id = dripid;
      this.batchService.getCallscript(id).subscribe((res) => {
        if (res) {
          this.callscrpt = res.CallerScript;
        }
      });
    }
  }

  getLettersAndNoticesTemplateListByTypeId() {
    this.letterAndNoticesService.getLettersAndNoticesTemplateListByTypeIdForOp(201).subscribe((response: ICommonList[]) => {
      if (response) {
        this.templateList = response;
      }
    });
  }

  onTemplateChange(event) {
    var templateID = parseInt(event);
    if (templateID) {
      this.getEmailBody(templateID);
      if (this.templateList) {
        this.selectedTemplateName = this.templateList.find((e) => e.Id == templateID).Name;
      }
    }
  }

  getEmailBody(id) {
    let obj = {
      InquiryNo: this.FollowUpData.InquiryNumber,
      ReservationNo: this.FollowUpData.ReservationNumber,
      LeaseNo: this.FollowUpData.LeaseNumber,
      FacilityId: this.FollowUpData.FacilityId,
      ToEmailAddress: '',
      FromEmailAddress: '',
      CCEmailAddress: '',
      BCCEmailAddress: '',
      CCToStoreEmailAddress: '',
      TransactionTypeId: 0,
      InvoiceNumber: 0,
      ReceiptNumber: 0,
      TenantLettersAndNoticesIds: [],
      TenantAlternateLettersAndNoticesIds: [],
      SendToAlternate: true,
      IpAddress: '',
      DripcampaignActionId: this.drpactionid,
      DripcampaignLetterId: id,
    };
    this.twoWayService.getBody(obj).subscribe((response: ISendEmailOutputModel) => {
      if (response && response.EmailModel) {
        this.mailfullContent = response;
        this.rteValue = this.mailfullContent.EmailModel.EmailBody;
        this.disableEmailSend = false;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe()
    }
  }

  getDayEndCompletedDate(facilityId) {
    this.generalService.getDayEndCompletedDate(facilityId).subscribe((response) => {
      if (response) {
        let FacilityDate = this.commonService.getFormattedDate(response.FacilityDateTime);
        this.remainderMinDate = new Date(FacilityDate);
        this.minDate = new Date(FacilityDate);
      }
    });
  }

  onChangeAssignedTo(eve) {
    if (eve) {
      this.isAssignedToUserGroup = eve.itemData.Category == 'User Group' ? true : false;
    } else {
      this.isAssignedToUserGroup = false;
    }
  }

  openCallSystem(): void {
    if (this.userSessionService.defaultPhoneSystem.PhoneSystemId === EUserFunctions.RingCentral) {
      this.ringCentralCTService.openRingCentralWidgetAndDial(this.FollowUpData.Phone);
    } else {
      window.location.href = `tel:+${this.CountryCode}${this.FollowUpData.Phone}`;
    }
  }

  getFacilityMiscellaneousSettings(facilityId) {
      this.prospectService.getFacilityMiscellaneousSettings(facilityId).subscribe((res) => {
        var miscellaneousSettings = res;
        if (miscellaneousSettings == null || miscellaneousSettings === "")
          this.propertyProtectionLabel = "Property Protection";
        else if (miscellaneousSettings.PropertyProtectionTerminology == null || miscellaneousSettings.PropertyProtectionTerminology === "")
          this.propertyProtectionLabel = "Property Protection";
        else
          this.propertyProtectionLabel = miscellaneousSettings.PropertyProtectionTerminology;
      });
  }

  openNotesModal() {
    this.getNotes(this.FollowUpData.FacilityId, this.FollowUpData.LeaseNumber);
    this.NotesPopup.show();
  }

  closeNotesPopup() {
    this.NotesPopup.hide();
  }

  getNotes(facilityID: number, leaseNo: number) {
    let request = {
      FacilityID: facilityID,
      LeaseNo: leaseNo,
      PageModel: null
    };
    this.customerService.GetCustomerUnitNotes(request)
      .subscribe((response: any[]) => {
        response.forEach(x => x.NotesDate = x.NotesDate?.replace('Z', ''));
        this.customerNotesList = response || [];
      });
  }

  getAlternateContactList(leaseId, facilityId) {
    this.customerService.getCustomerAlternateContacts(leaseId, facilityId).subscribe((response: any) => {
      this.alternateContactInfoList = response;
    });
  }

  ShowalternateContact() {
    this.gotoalternateContact = true;
    this.AlternateContactPopUp.show();
  }
    CancelAlternantePopUp() {
    this.gotoalternateContact = false;
    this.AlternateContactPopUp.hide();
  }

  checkGateSystemIntegrated(facilityId) {
    this.loaderIcon = Promise.resolve(true);
    this.prospectService.CheckFacilityGateSettingExist(facilityId).subscribe((response: IResponseModel) => {
      this.gateSystemResponse = response;
    });
  }
}
